import { useState } from "react";
import { ChevronDown, ChevronUp } from "lucide-react";

const FAQ = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const faqs = [
    {
      question: "What is the minimum order quantity?",
      answer: "Our minimum order quantities vary by package: Pro Custom requires 500+ bags, Full Custom requires 300+ bags, and our Semi-Custom | IN STOCK option has no minimum order requirement, making it perfect for smaller clubs."
    },
    {
      question: "How long does production take?",
      answer: "Production times depend on the package you choose. Pro Custom and Full Custom packages take 90+ days after design approval, while our Semi-Custom | IN STOCK option has a quick 3-week turnaround time."
    },
    {
      question: "What's customizable?",
      answer: "We offer extensive customization options! Depending on your package, you can customize colors, add up to 8 custom prints, personalize color panels, liners, zipper tabs, mesh pockets, and more. You can add your team logo, sponsor logos, and custom text in various print locations. Our team will work with you during the design phase to create backpacks that perfectly represent your team or organization."
    },
    {
      question: "Can I customize the colors of the backpack?",
      answer: "Yes! Our Pro Custom package offers fully custom design and colors including custom color panels, liners, zipper tabs, and mesh pockets. Full Custom offers custom liners and zipper tabs with a black bag base. Semi-Custom offers Black or Navy bag options."
    },
    {
      question: "How many custom prints can I add?",
      answer: "This depends on your chosen package. Pro Custom and Full Custom packages allow up to 8 custom prints, while Semi-Custom includes 2 custom prints with up to 5 print locations possible."
    },
    {
      question: "Do you offer samples before bulk orders?",
      answer: "Yes, we can provide samples for our packages. Please contact us at Info@apacustom.com or call 1-800-429-1223 to discuss sample options and pricing."
    },
    {
      question: "What types of organizations do you work with?",
      answer: "We work with a wide range of sports establishments including volleyball clubs, basketball teams, soccer clubs, MMA gyms, schools, and many other sports organizations. If you're part of a sports team or club, we can help you create custom backpacks!"
    },
    {
      question: "How do I request a quote?",
      answer: "You can request a quote by clicking the 'Request Quote' or 'Design Yours' buttons throughout our website, or by visiting our Contact page. Fill out the form with your details and customization needs, and we'll get back to you promptly."
    },
    {
      question: "What makes Apa Custom different from other backpack companies?",
      answer: "We specialize in custom sport backpacks with a focus on quality, durability, and affordability. We offer flexible minimum orders, work closely with our clients to understand their needs, and provide exceptional customer care throughout the design and production process."
    }
  ];

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="min-h-screen pt-24 pb-20" data-testid="faq-page">
      <div className="container mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
            Frequently Asked Questions
          </h1>
          <p className="text-base sm:text-lg text-gray-700 max-w-2xl mx-auto" style={{ fontFamily: 'Inter, sans-serif' }}>
            Find answers to common questions about our custom backpack services
          </p>
        </div>

        {/* FAQ Accordion */}
        <div className="max-w-4xl mx-auto space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-sm hover:shadow-md transition-all duration-300 overflow-hidden"
              data-testid={`faq-item-${index}`}
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-8 py-6 flex items-center justify-between text-left"
                data-testid={`faq-question-${index}`}
              >
                <h3 className="text-lg font-bold text-gray-900 pr-8" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
                  {faq.question}
                </h3>
                {openIndex === index ? (
                  <ChevronUp className="w-6 h-6 text-gray-900 flex-shrink-0" />
                ) : (
                  <ChevronDown className="w-6 h-6 text-gray-900 flex-shrink-0" />
                )}
              </button>
              {openIndex === index && (
                <div
                  className="px-8 pb-6 text-gray-700 text-base leading-relaxed"
                  style={{ fontFamily: 'Inter, sans-serif' }}
                  data-testid={`faq-answer-${index}`}
                >
                  {faq.answer}
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Contact CTA */}
        <div className="mt-16 text-center max-w-2xl mx-auto">
          <div className="bg-gray-50 rounded-2xl p-8">
            <h3 className="text-2xl font-bold text-gray-900 mb-4" style={{ fontFamily: 'Space Grotesk, sans-serif' }}>
              Still Have Questions?
            </h3>
            <p className="text-gray-700 mb-6" style={{ fontFamily: 'Inter, sans-serif' }}>
              Can't find the answer you're looking for? Our team is here to help!
            </p>
            <div className="space-y-2 text-gray-700" style={{ fontFamily: 'Inter, sans-serif' }}>
              <p>Email: <a href="mailto:Info@apacustom.com" className="text-gray-900 font-medium hover:underline">Info@apacustom.com</a></p>
              <p>Phone: <a href="tel:1-800-429-1223" className="text-gray-900 font-medium hover:underline">1-800-429-1223</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FAQ;
